export default __webpack_public_path__ + "static/media/money-back@2x.7bdbd4ab.png";